export * from './tab-group';
export * from './tabs.module';
